import styled from '@emotion/styled'

export const StyledRecommendation = styled.div`

    
`